module.exports = __webpack_public_path__ + "img/lt.ed8100f9.svg";